import { combineReducers } from "@reduxjs/toolkit";

import setConfigDataReducer from "./setConfigSlice";
import toolSelectReducer from "./toolSelectSlice";
import layerOptionsReducer from "./optionsSlice";
import setResultsReducer from "./resultsSlice";
import identifyOptionsReducer from "./identifySlice";
import updateQuerySliceReducer from "./querySlice";
import baseMapConfigSliceReducer from "./baseMapConfigSlice";
import editingSliceReducer from "./editingSlice";
import permissionSliceReducer from "./permissionSlice";
const rootReducer = combineReducers({
    toolSelect: toolSelectReducer,
    configData: setConfigDataReducer,
    layerOptions: layerOptionsReducer,
    resultsData: setResultsReducer,
    identifyOptions: identifyOptionsReducer,
    query: updateQuerySliceReducer,
    baseMapsConfig: baseMapConfigSliceReducer,
    editingOptions: editingSliceReducer,
    authorizedPermissions: permissionSliceReducer,
});

export default rootReducer;
